<template>
  <div class="form-control restricted-textarea">
    <label
      :class="getColor()"
      :data-limit="`${inputValue.length}/${limit}`"
    >
      <textarea
        rows="4"
        :placeholder="placeholder"
        v-model="inputValue"
        :maxlength="limit"
        :disabled="isDisabled"
        :class="textColorClass"
        @focus="enableShowLimit"
        @blur="disableShowLimit"
        v-validate="{required: `${required}`}"
      ></textarea>
    </label>
    <div v-if="showNotice">
      <p class="notice-message">Comments should not be longer than {{limit}} characters</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RestrictedTextArea',
  props: {
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    input: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    limit: {
      type: Number,
      required: false,
      default: 255,
    },
    warningLimit: {
      type: Number,
      required: false,
      default: 100,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    showNotice: {
      type: Boolean,
      required: false,
      default: true,
    },
    textColorClass: {
      type: String,
      default: 'black-text',
    },
  },
  data() {
    return {
      showLimit: false,
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.input || '';
      },
      set(value) {
        this.$emit('inputUpdated', value);
      },
    },
    charactersRemaining() {
      return this.limit - this.inputValue.length;
    },
  },
  methods: {
    enableShowLimit() {
      this.showLimit = true;
    },
    disableShowLimit() {
      this.showLimit = false;
    },
    getColor() {
      if (!this.showLimit) {
        return 'transparent-text';
      }
      const numberOfCharacters = this.inputValue.length;

      if (numberOfCharacters === 0) {
        return '';
      }
      if (numberOfCharacters > 0 && numberOfCharacters <= this.warningLimit) {
        return 'green-text';
      } else if (
        numberOfCharacters > this.warningLimit &&
        numberOfCharacters < this.limit
      ) {
        return 'yellow-text';
      }
      return 'red-text';
    },
  },
};
</script>

<style scoped>
.green-text {
  color: #558c1d;
}

.yellow-text {
  color: #e58a2d;
}

.red-text {
  color: #8c1d1d;
}

.vinous-text {
  color: #dc0000;
  background: transparent;
  height: auto;
}

.black-text {
  color: black;
}

.transparent-text {
  color: transparent;
}

.instructions-label {
  color: #797979;
  font-weight: 300;
  margin-bottom: 10px;
}

textarea {
  border: none;
  resize: none;
  width: 90%;
}

label,
textarea {
  position: relative;
  display: block;
  box-sizing: border-box;
  height: 140px;
}

.form-control {
  height: 150px;
}

textarea {
  width:100%;
  color: black;
  font-weight: normal !important;
  margin-bottom: 15px !important;
}

.input-with-label {
  color: transparent !important;
}

label::after {
  content: attr(data-limit);
  position: absolute;
  top: 4px;
  right: 21px;
  padding-top: 5px;
  font-size: 12px;
  display: block;
}
 .notice-message {
   font-style: italic;
   color: #FF0000;
   margin-left: -13px;
 }

</style>



// WEBPACK FOOTER //
// RestrictedTextArea.vue?6dd3a7d1